import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import InfoIcon from '@mui/icons-material/Info';
import {
    Box,
    Container,
    FormControl,
    FormHelperText,
    Popover,
    Typography,
} from '@mui/material';

export const FreeTextSearch = (props: any) => {
    const { value, onHandleChange, onHandleQuickSearch, onHandleClear } = props;
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const handleClear = () => {
        if (onHandleClear) {
            onHandleClear();
        } else {
            onHandleChange({ target: { value: '' } });
        }
    };

    return (
        <FormControl variant="outlined" fullWidth>
            <TextField
                id="filled-search"
                label="Quick Text Search"
                variant="outlined"
                type="text"
                value={value}
                onChange={onHandleChange}
                size="small"
                onKeyUpCapture={(ev) => {
                    if (ev.key === 'Enter') {
                        onHandleQuickSearch();
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {value && (
                                <IconButton onClick={handleClear}>
                                    <ClearIcon />
                                </IconButton>
                            )}
                            <IconButton onClick={onHandleQuickSearch}>
                                <SearchIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <FormHelperText>
                <Typography
                    variant="inherit"
                    aria-owns={open ? 'mouse-over-popover' : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={handlePopoverClose}
                >
                    <InfoIcon sx={{ fontSize: 14 }} color="disabled" />
                    <span style={{ marginLeft: 3 }}>
                        Filter analytics by entering keywords
                    </span>
                </Typography>
                <Popover
                    id="mouse-over-popover"
                    sx={{
                        pointerEvents: 'none',
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                >
                    <Container
                        style={{
                            backgroundColor: 'primary',
                            paddingBottom: '1rem',
                        }}
                    >
                        <Typography
                            color={'primary'}
                            variant={'body1'}
                            fontWeight="bold"
                            paddingTop={2}
                        >
                            Quick Text Search Tips
                        </Typography>
                        <br></br>
                        <Typography
                            color={'primary'}
                            variant={'body2'}
                            style={{ fontWeight: 'bold' }}
                        >
                            Exact vs. Partial Match:
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            Without quotes: Searches for individual words.
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            With quotes: Finds exact phrases.
                        </Typography>
                        <br></br>
                        <Typography
                            color={'primary'}
                            variant={'body2'}
                            style={{ fontWeight: 'bold' }}
                        >
                            Exclude Words:
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            Use a minus sign ("-") to exclude specific words.
                        </Typography>
                        <br></br>
                        <Typography
                            color={'primary'}
                            variant={'body2'}
                            style={{ fontWeight: 'bold' }}
                        >
                            Examples:
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            "coffee shop": Exact match.
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            coffee shop -tea: Excludes "tea".
                        </Typography>
                        <Typography color={'primary'} variant={'body2'}>
                            "tea" “coffee shop": Includes "coffee shop" but may
                            also have "tea".
                        </Typography>
                        <br></br>
                        <Box display="inline">
                            <Typography
                                color={'primary'}
                                variant={'body2'}
                                fontWeight="bold"
                                display="inline"
                            >
                                Bonus Tip:
                            </Typography>
                            <Typography
                                color={'primary'}
                                variant={'body2'}
                                display="inline"
                            >
                                {' '}
                                You can also search by Case ID.
                            </Typography>
                        </Box>
                    </Container>
                </Popover>
            </FormHelperText>
        </FormControl>
    );
};

export default FreeTextSearch;
